import {
    LOGIN_STARTED,
    LOGIN_SUCCESS,
    LOGIN_FAILURE
} from '../actions/actionTypes';

const initialState = {
    loading: true,
    user: null,
    error: null,
    isAuthenticated: false
};

export function loginReducer(state = initialState, action) {
    switch (action.type) {
        case LOGIN_STARTED:
            return {
                ...state
            };
        case LOGIN_SUCCESS:
            return {
                loading: false,
                user: action.payload.userData,
                isAuthenticated: true
            };
        case LOGIN_FAILURE:
            return {
                error: action.payload,
                ...state
            };
        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/reducers/login.js